import React from "react";
import { Navigate, useParams } from "react-router-dom";

const OrderTrackingRedirect: React.FC = () => {
	const { id } = useParams<{ id: string }>();

	if (!id) {
		return <Navigate to="/main" replace />;
	}

	return (
		<Navigate to={`/order-tracking?id=${encodeURIComponent(id)}`} replace />
	);
};

export default OrderTrackingRedirect;
